import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    getSegmentTaxonomy,
    getSegmentTags,
    getSegmentMLTags,
    getSegmentTotalTags,
    getSegmentTagsLoading,
    getSegmentId,
    getChallengeId,
} from '../selectors';
import { getUserPermissionsKeys } from '../../auth/selectors';
import { PropTypes } from 'prop-types';
import { segmentTagsRequested } from '../actions';
import TopTagsCard from '../../../common/TopTagsCard';
import { TAXONOMY_DROPDOWN as DROPDOWN } from '../../../common/constants';
function SegmentTags({
    segmentId,
    onSelect,
    tags,
    mlTags,
    total,
    taxonomy,
    loading,
    challengeId,
    permissions,
}) {
    const selectedTaxonomy = DROPDOWN[0].key;

    // reset selected taxonomy if a new challenge is selected
    useEffect(() => {
        if (segmentId) onSelect(selectedTaxonomy);
    }, [challengeId]);

    // reset segment tags when a user selects a new segment
    useEffect(() => {
        if (segmentId) onSelect(taxonomy);
    }, [segmentId]);

    const mainContent = segmentId ? (
        <TopTagsCard
            id={'-segment-tags'}
            taxonomy={taxonomy}
            onTaxonomySelect={onSelect}
            topTags={tags}
            tagsLoading={loading}
            totalTags={total}
            mlTags={mlTags}
            permissions={permissions}
        />
    ) : null;

    return mainContent;
}

SegmentTags.propTypes = {
    segmentId: PropTypes.number,
    challengeId: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    tags: PropTypes.arrayOf(PropTypes.object),
    mlTags: PropTypes.arrayOf(PropTypes.object),
    total: PropTypes.string,
    taxonomy: PropTypes.string,
    loading: PropTypes.bool,
    permissions: PropTypes.arrayOf(PropTypes.string),
};

SegmentTags.defaultProps = {
    segmentId: null,
    challengeId: null,
    tags: [],
    mlTags: [],
    total: '0',
    taxonomy: '',
    loading: false,
    permissions: [],
};

const mapStateToProps = (state) => {
    return {
        total: getSegmentTotalTags(state),
        tags: getSegmentTags(state),
        mlTags: getSegmentMLTags(state),
        taxonomy: getSegmentTaxonomy(state),
        loading: getSegmentTagsLoading(state),
        segmentId: getSegmentId(state),
        challengeId: getChallengeId(state),
        permissions: getUserPermissionsKeys(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSelect: (taxonomy) => dispatch(segmentTagsRequested(taxonomy)),
    };
};

const ConnectedTopTags = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SegmentTags);

export default ConnectedTopTags;
